import * as types from './types'

export default {
  [types.TASKS]: state => {
    return state.tasks
  },
  [types.MILESTONES]: state => {
    return state.milestones
  },
  [types.SECONDARY_GOALS]: state => {
    return state.secondaryGoals
  },
}
